export default "__VITE_ASSET__BOG0IaxD__"